export enum SubDomain {
  OPLEVBRONDBY = 'oplevbrondby',

  // DK
  AARHUSBRYGHUS = 'aarhusbryghus',
  BEGHUSET = 'beghuset',
  DEFAULT = 'default',

  // PL
  ONLINE_INTERTICKET_PL = 'online.interticket.pl',
  TEATR_MALY = 'teatrmaly',
  MEDITACJE_PL = 'online-medytacje',

  // HU
  ONLINE_JEGY_HU = 'online.jegy.hu',
  TSU_JEGY_HU = 'online-tsu',
  ODZ_JEGY_HU = 'online-odz',
  MALADYPE_JEGY_HU = 'online-maladype',
  KODALYFILHARMONIA_JEGY_HU = 'online-kodalyfilharmonia',
  PFZ_JEGY_HU = 'online-pfz',
  FOVAROSI_NAGYCIRKUSZ = 'online-fnc',
  BDZ_JEGY_HU = 'online-bdz',
  ESERNYOS_JEGY_HU = 'online-esernyos',
  GITARFESZT_JEGY_HU = 'online-budapestguitar',
  BUDAVAR_JEGY_HU = 'online-budavar',
  VARKERT_BAZAR_JEGY_HU = 'online-varkertbazar',
  MILLENARIS_JEGY_HU = 'online-millenaris',
  HAGYOMANYOK_HAZA_JEGY_HU = 'online-hagyomanyokhaza',
  ZENEACADEMY_JEGY_HU = 'online-lisztacademy',
  ATRIUM_JEGY_HU = 'online-atrium',
  HARANGROZSA_JEGY_HU = 'online-hangrozsa',
  PANNONVARSZINHAZ_JEGY_HU = 'online-pannonvarszinhaz',
  RENDBENVAN_JEGY_HU = 'online-rendbenvan',
  KOLIBRISZINHAZ_JEGY_HU = 'online-kolibriszinhaz',
  JMMH_JEGY_HU = 'online-jmmh',
  PESTI_MAGYAR_SZINHAZ_JEGY_HU = 'online-pestimagyarszinhaz',
  TINTANYUL_JEGY_HU = 'online-tintanyul',
  SPINOZA_JEGY_HU = 'online-spinoza',
  FONIX_JEGY_HU = 'online-fonixrendezveny',
  AZONGORA_JEGY_HU = 'online-azongora',
  FABULA_JEGY_HU = 'online-fabulababszinhaz',
  BABSZINHAZ_JEGY_HU = 'online-budapestbabszinhaz',
  BETHLEN_JEGY_HU = 'online-bethlenszinhaz',
  NEFELEJCS_JEGY_HU = 'online-nefelejcsbabszinhaz',
  GYORI_NEMZETI_JEGY_HU = 'online-gyoriszinhaz',
  ZICHY_JEGY_HU = 'online-zichyszinmuhely',
  CSIK_JEGY_HU = 'online-csikzenekar',
  SPIRIT_JEGY_HU = 'online-spiritszinhaz',
  MAV_JEGY_HU = 'online-mavzenekar',
  SZENTENDRE_JEGY_HU = 'online-szentendre',
  SZEGED_SZABADTERI_JEGY_HU = 'online-szegediszabadteri',
  SZOLNOKI_SZIGLIGETI_JEGY_HU = 'online-szigligetiszinhaz',
  B32_JEGY_HU = 'online-b32',
  PINTER_BELA_JEGY_HU = 'online-pbest',
  GOZON_JEGY_HU = 'online-gozongyula',
  BOGGIE_JEGY_HU = 'online-boggieproduction',
  BEKESCSABAI_JOKAI_JEGY_HU = 'online-jokaiszinhaz',
  LATHATARON_JEGY_HU = 'online-lathataroncsoport',
  CIROKA_JEGY_HU = 'online-ciroka',
  OPERETT_JEGY_HU = 'online-operett',
  BARTOK_JEGY_HU = 'online-bartokszinhaz',
  PODCAST_SHOW_JEGY_HU = 'online-podcastshow',
  ROXINHAZ_JEGY_HU = 'online-roxinhaz',
  LASZLO_ATTILA_JEGY_HU = 'online-laszloattila',
  VERES_1_JEGY_HU = 'online-veres1szinhaz',
  CSANYI_JEGY_HU = 'online-csanyisandorprodukcio',
  KARAVAN_JEGY_HU = 'online-karavanszinhaz',
  URANIA_NEMZETI_JEGY_HU = 'online-uranianf',
  MISKOLCI_VSZ_JEGY_HU = 'online-miskolcivsz',
  JASZAI_MARI_JEGY_HU = 'online-jaszaiszinhaz',
  TRAFO_JEGY_HU = 'online-trafo',
  TULIPANTUNDER_JEGY_HU = 'online-tulipantunder',
  RAKASZ_GERGELY_JEGY_HU = 'online-rakaszgergely',
  PINCE_JEGY_HU = 'online-pinceszinhaz',
  NAPILAPCSOPORT_JEGY_HU = 'online-napilapcsoport',
  GOLEMSZINHAZ_JEGY_HU = 'online-golemszinhaz',
  MERRYGOROUND_JEGY_HU = 'online-merrygoround',
  DUMASZINHAZ_JEGY_HU = 'online-dumaszinhaz',
  KULTURKOZPONT_JEGY_HU = 'online-kulturkozpont',
  BUDAPESTKLEZMERBAND_JEGY_HU = 'online-budapestklezmerband',
  TOBEART_JEGY_HU = 'online-tobeart',
  NEWU_JEGY_HU = 'online-newu',
  SASIPRODUKCIO_JEGY_HU = 'online-sasiprodukcio',
  KAPOSMUSICAL_JEGY_HU = 'online-kaposmusical',
  MAO_JEGY_HU = 'online-mao',
  OPERA_OTTHONRA_JEGY_HU = 'online-operaotthonra',
  PANNONIA_ENTERTAINMENT_JEGY_HU = 'online-pannoniaentertainment',
  BUDAPEST_JAZZ_JEGY_HU = 'online-bjc',
  HATSZIN_TEATRUM_JEGY_HU = 'online-hatszin',
  GYORI_BALETT_JEGY_HU = 'online-gyoribalett',
  VIRTUOZOK_JEGY_HU = 'online-virtuozok',
  FONO_BUDAI_JEGY_HU = 'online-fono',
  VOROSMARTY_JEGY_HU = 'online-vorosmartyszinhaz',
  QUIMBY_JEGY_HU = 'online-quimby',
  BAGOSSY_BROTHERS_JEGY_HU = 'online-bagossybrotherscompany',
  NEMZETI_TANCSZINHAZ_JEGY_HU = 'online-nemzetitancszinhaz',
  SZEGEDI_NEMZETI_JEGY_HU = 'online-szegedinemzeti',
  VIGSZINHAZ_JEGY_HU = 'online-vigszinhaz',
  MOZGO_MOZI_JEGY_HU = 'online-mozgomozi',
  DUNA_TANCMUHELY_JEGY_HU = 'online-dunatancmuhely',
  SZKENE_JEGY_HU = 'online-szkene',
  PINDROCH_JEGY_HU = 'online-pindrochcsaba',
  SOLTIS_LAJON_JEGY_HU = 'online-soltisszinhaz',
  CSANYI_ZART_JEGY_HU = 'online-csanyiprodukcio-zart',

  // ML
  ONLINE_MFA = 'online-mfa',

  // USA
  EVAALEXIS = 'evaalexis'
}
